<template>
  <quill-editor
    :disabled="readOnly"
    v-model="model.$model"
    ref="refQuillEditor"
    :options="quillOptions"
  ></quill-editor>
</template>

<script>
export default {
  props: {
    model: {
      required: false,
      default: () => {},
    },
    readOnly: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      quillOptions: {
        placeholder: "",
        modules: {
          toolbar: [
            ["bold", "italic", "underline", "strike"], // toggled buttons
            ["blockquote", "code-block"],
            ["link", "image", "video", "formula"],

            [{ header: 1 }, { header: 2 }], // custom button values
            [{ list: "ordered" }, { list: "bullet" }, { list: "check" }],
            [{ script: "sub" }, { script: "super" }], // superscript/subscript
            [{ indent: "-1" }, { indent: "+1" }], // outdent/indent
            [{ direction: "rtl" }], // text direction

            [{ size: ["small", false, "large", "huge"] }], // custom dropdown
            [{ header: [1, 2, 3, 4, 5, 6, false] }],

            [{ color: [] }, { background: [] }], // dropdown with defaults from theme
            [{ font: [] }],
            [{ align: [] }],

            ["clean"],
          ],
        },
      },
    };
  },
};
</script>

<style scoped>
.navbar {
  /* padding-top: 100px; */
  z-index: 1031;
}

.navbar-heading {
  text-align: left;
  font-weight: 700;
}

.sidebar-icon {
  width: 25px;
  text-align: left;
}

.nav-link {
  padding: 0.7rem 1.5rem;
}

.navbar-vertical.navbar-expand-md {
  padding-right: 1em;
  padding-left: 1em;
}
</style>
